const routes = {
  HOME: '/',
  SCHEMA: '/schema',
  EDIT_SCHEMA: '/schema/edit',
  SHARE_SCHEMA: '/schema/share',
  MOCK_DATA: '/mock-data',
  DATASOURCES: '/datasources',
  AUTH: '/auth',
};

export default routes;
